import { render } from "./ProfileBase.vue?vue&type=template&id=94539212"
import script from "./ProfileBase.vue?vue&type=script&lang=js"
export * from "./ProfileBase.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./ProfileBase.vue?vue&type=style&index=0&id=94539212&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script